import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Email.svg?component
var Email_exports = /* @__PURE__ */ __exportAll({
	default: () => Email_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M2.25 4.5h19.5s1.5 0 1.5 1.5v12s0 1.5-1.5 1.5H2.25s-1.5 0-1.5-1.5V6s0-1.5 1.5-1.5m13.437 5.475L19.5 13.5M8.313 9.975 4.5 13.5" }, null, -1), createElementVNode("path", { d: "m22.88 5.014-9.513 6.56a2.41 2.41 0 0 1-2.734 0L1.12 5.014" }, null, -1)])]);
}
var Email_default = { render: render$1 };
//#endregion
export { Email_exports, Email_default as default, render$1 as render };

//# sourceMappingURL=Email.svg_component.js.map